<script>
	import { Router, Route, Link } from 'svelte-routing';

	import Index from './pages/Index.svelte';
	import Rosary from './pages/Rosary.svelte';
	import Settings from './pages/Settings.svelte';

	export let url = "";
</script>

<template>
	<Router url="{url}">
		<div class="wrapper">
			<nav>
				<div><Link to="/">Home</Link></div>
				<div><Link to="/rosary">Rosary</Link></div>
				<div><Link to="/settings">Settings</Link></div>
			</nav>
			<div class="container">
				<Route path="/" component={Index} />
				<Route path="/rosary" component={Rosary} />
				<Route path="/settings" component={Settings} />
			</div>
		</div>
	</Router>
</template>

<style lang="stylus">
	.wrapper
		height 100vh
		background black
		display flex
		flex-direction column
		color white
		font-family 'Lora', serif

	nav
		display flex
		align-items center
		justify-content center
		padding 1rem

		div
			margin 0 1rem

	:global(a)
		color white
		text-decoration none
		display block

		&:hover
			color black
			background white

	.container
		height 100%
		display flex
		align-items center
		justify-content center
		flex-direction column
</style>
